module.exports = __webpack_public_path__ + "img/pic_nosucai@2x.5ec5bc0f.png";